module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-detailed-statistics@2x-f30a9abe7fa05b80ad49ae720a6e4edf.png";